var prodcat = prodcat || {};

prodcat.data = prodcat.data || {};
var site = site || {};

site.client = site.client || {};
site.direction = site.direction || {};

(function ($) {
  $(document).on('product.skuSelect', '.js-product', function (e, skuBaseId, drammingOption) {
    var $template = $('.js-product-full-image-v2', $(this));

    if ($template.length <= 0) {
      return null;
    }

    $template.data('altTextProcessed', false);
    Drupal.behaviors.productFullImageV2.updateImages($template, skuBaseId, drammingOption);
  });
  Drupal.behaviors.productFullImageV2 = {
    attach: function (context) {
      if (this.attached) {
        return;
      }
      var self = this;
      var $containers = $('.js-product-full-image-v2', context);

      self.attached = true;
      $containers.each(function () {
        var $container = $(this);

        self.initMainImageCarousel($container);

        $(window).on(
          'resize',
          _.debounce(function () {
            self.initMainImageCarousel($container);
          }, 100)
        );
      });
    },

    // track expand
    isExpanded: false,

    initMainImageCarousel: function ($container, index) {
      var currentBpWidth = parseInt(Unison.fetch.now().width, 10);
      var bPportraitUp = parseInt(Unison.fetch.all()['portrait'], 10);
      var isDesktop = currentBpWidth >= bPportraitUp;
      var $imgContainer = $('.product-full-image__main-grid-image', $container);
      var carouselArrows = !Drupal.settings.global_variables.cr24 ? false : true;
      var $imageBadge = $container.find('.js-product-full-image__image-badge');

      index = index || 0;

      // Unslick the carousel to turn into grid
      if (isDesktop) {
        $('.product-full-image__main-grid-image.slick-initialized', $container).unslick(
          '.product-full-image__main-grid-image'
        );

        return;
      }

      // case for custom slides count and dots for mobile
      var settings = {
        rtl: site.direction.isRTL,
        infinite: true,
        mobileFirst: true,
        arrows: carouselArrows,
        dots: true,
        speed: 300,
        slide: '.js-product-full-image__img-wrap, .js-video-block__media',
        initialSlide: index,
        slidesToShow: 1,
        slidesToScroll: 1,
        onAfterChange: function (args) {
          var drupalAnalytics = Drupal.settings.analytics.alt_image_tagging_enabled;

          if (drupalAnalytics) {
            $(document).trigger('SLICKCHANGE');
          }

          if (args.currentSlide !== 0) {
            $imageBadge.addClass('hidden');
          } else {
            $imageBadge.removeClass('hidden');
          }
        }
      };

      // Init the grid into carousel with our settings
      $imgContainer.not('.slick-initialized').slick(settings);
      // Hack to set the active image of the slick slider.
      $imgContainer.slickGoTo(index);
    },
    updateImages: function ($container, skuBaseId, drammingOption) {
      var self = this;
      var skuData = prodcat.data.getSku(skuBaseId);
      var productData = prodcat.data.getProduct(skuData.PRODUCT_ID);
      var $mainImages = $('.js-product-full-image-main-photo', $container);
      var $imageActive = $('.js-product-full-image__img-wrap.slick-active', $container);
      var $videoContainerWrappers = $(
        '.js-product-full-image__main-alt-videos .js-product-full-image__img-wrap',
        $container
      );
      var $videoContainers = $('.js-video-block__media', $videoContainerWrappers);
      var $videoInlineContainers = $(
        '.js-product-full-image__video-inline',
        $videoContainerWrappers
      );
      var videoExists = productData.VIDEO_SOURCE ? !!productData.VIDEO_SOURCE.length : 0;
      var index = $imageActive.attr('index') || 0;
      var $imgCollection = $('.js-product-full-image-main', $container);
      var currentPageWidth = parseInt(Unison.fetch.now().width, 10);
      var pagePortraitUp = parseInt(Unison.fetch.all()['portrait'], 10);
      var isDesktop = currentPageWidth >= pagePortraitUp;
      var arrLen = 0;
      var imgLen = 0;
      var len = 0;
      var $mainImage;
      var $mainImageContainer;
      var mainImageHeight;
      var $divNew;
      var $videoActive;
      var imageGridRows;
      var imageGridRowsGaps;
      var imageGridHeight;
      var swapImageField = $mainImages.data('swapImageField') || 'IMAGE_LARGE_COMBINED';
      var $imgContainer = $('.js-product-main-grid-image', $container);
      var zoomLabel = $imgContainer.data('zoom-aria-label');
      var closeLabel = $imgContainer.data('zoom-close-aria-label');
      var scrollToHeight = 0;
      var $mainImagesWrapper;
      var $newZoomIcon;
      var $zoomIcon;
      var isProductImageResponsive =
        Drupal.settings.global_variables &&
        Drupal.settings.global_variables.product_responsive_images;
      var baseImagePath;
      var imageSrcset;
      var siteName = (Drupal.settings.common && Drupal.settings.common.site_name + ', ') || '';
      var skuName = skuData.SHADENAME || skuData.PRODUCT_SIZE || '';
      var productName = productData.PROD_RGN_NAME + ', ' || '';
      var imageAltText = siteName + productName + skuName;
      var $imageBadge = $container.find('.js-product-full-image__image-badge');
      var featureFlags = Drupal.settings.featureFlags || {};
      var $toggleBtn;
      var altImageLimit = 6;
      var $textBadge = $container.find('.js-product-full-image__text-badge');

      // Ensure only one text badge exists (updateImages assumes a single element).
      if ($textBadge.length > 1) {
        $textBadge.slice(1).remove();
        $textBadge = $textBadge.first();
      }

      self.isExpanded = false;

      function collapseImages($wraps) {
        var totalAlt = $wraps.length;

        if (totalAlt <= altImageLimit) {
          $toggleBtn.hide();
          $wraps.show();
          self.isExpanded = false;
          $imgCollection.css({ height: 'auto' });
          return;
        }

        $wraps.each(function (j) {
          $(this).toggle(j < altImageLimit);
        });
        self.isExpanded = false;
        $toggleBtn.find('.expand').removeClass('hidden');
        $toggleBtn.find('.collapse').addClass('hidden');
        $imgCollection.css({ height: 'auto' });
      }

      function expandImages($wraps) {
        $wraps.show();
        self.isExpanded = true;
        $toggleBtn.find('.collapse').removeClass('hidden');
        $toggleBtn.find('.expand').addClass('hidden');
        $imgCollection.css({ height: 'auto' });
      }

      function resizeImageGrid() {
        var $visibleImages = $mainImagesWrapper.filter(':visible');
        var visibleCount = $visibleImages.length;

        if (visibleCount > 0) {
          mainImageHeight = $mainImages.outerWidth(true);
          imageGridRows = Math.max(Math.round((visibleCount - 1) / 2), 1);
          imageGridRowsGaps = 20 * (imageGridRows - 1);
          imageGridHeight = mainImageHeight * imageGridRows + imageGridRowsGaps;
          $imgCollection.css({ height: imageGridHeight > 0 ? imageGridHeight : 'auto' });
        } else {
          $imgCollection.css({ height: 'auto' });
        }
      }

      var productFullImageSrcsetSizes = [
        {
          size: '440',
          xDescriptor: '440w'
        },
        {
          size: '768',
          xDescriptor: '768w'
        },
        {
          size: '1200',
          xDescriptor: '1200w'
        }
      ];

      // Unslick the main image carousel
      $('.product-full-image__main-grid-image.slick-initialized', $container).unslick(
        '.product-full-image__main-grid-image'
      );

      // Load the bundle SKU images when page get load first time for dramming product
      if (drammingOption === 'noshade') {
        skuData = page_data['catalog-spp-dramming']['products'][0].defaultSku;
      }

      if (!_.isNull(skuData)) {
        if (_.isArray(skuData[swapImageField]) && skuData[swapImageField].length > 0) {
          // Unslick the main image carousel before we update the images
          $('.product-full-image__main-grid-image.slick-initialized', $container).unslick(
            '.product-full-image__main-grid-image'
          );
          $mainImages = $('.js-product-full-image-main-photo', $container);
          arrLen = skuData[swapImageField].length;
          imgLen = $mainImages.length;
          len = arrLen > imgLen ? arrLen : imgLen;
          $mainImageContainer = $('.product-full-image__main-grid-image', $container);
          $mainImageContainer.html('');

          if (skuData.MISC_FLAG_TEXT !== null && skuData.MISC_FLAG_TEXT !== '') {
            $textBadge.html(skuData.MISC_FLAG_TEXT);
          } else {
            $textBadge.html(productData.MISC_FLAG_TEXT || '');
          }

          for (var i = 0; i < len; i++) {
            if (imgLen >= i + 1) {
              $mainImage = $($mainImages.get(i));
            } else {
              if ($mainImages.length > 1) {
                $mainImage = $mainImages.filter(':not(.active)').first().clone();
              } else {
                $mainImage = $mainImages.first().clone();
              }
            }

            if ($container.data().altTextProcessed !== true) {
              $mainImage.attr('alt', imageAltText);
              $container.data('altTextProcessed', true);
            }

            $newZoomIcon = $('<div/>')
              .addClass('product-full-image__zoom-icon js-product-image-zoom-icon')
              .attr({ tabindex: '0', 'aria-label': zoomLabel });
            // Remove the extra image objs if the new image array is smaller
            if (arrLen >= i + 1) {
              $divNew = $('<div/>')
                .addClass('product-full-image__img-wrap js-product-full-image__img-wrap')
                .appendTo($mainImageContainer)
                .append($mainImage)
                .append($newZoomIcon)
                .fadeIn(400);
              $mainImage.attr('src', skuData[swapImageField][i]);
              if (isProductImageResponsive) {
                baseImagePath = skuData[swapImageField][i].split('?')[0];
                imageSrcset = '';
                productFullImageSrcsetSizes.forEach((imageSrcsetSize) => {
                  imageSrcset += `${baseImagePath}?width=${imageSrcsetSize.size}&height=${imageSrcsetSize.size} ${imageSrcsetSize.xDescriptor},`;
                });
                imageSrcset = imageSrcset.slice(0, -1);
                if ($mainImage.hasClass('lazyload')) {
                  $mainImage.attr('data-srcset', imageSrcset);
                } else {
                  $mainImage.attr('srcset', imageSrcset).attr('data-srcset', imageSrcset);
                }
              }
            } else {
              $mainImage.fadeOut(400, function () {
                $(this).remove();
              });
            }
          }

          if (isDesktop) {
            if ($imgContainer.hasClass('img-zoom-view')) {
              $imgContainer.removeClass('img-zoom-view');
              $videoContainerWrappers.removeClass('img-zoom-view');
            }
            mainImageHeight = $mainImages.outerWidth(true);
            imageGridRows = Math.max(Math.round((arrLen - 1) / 2), 1);
            imageGridRowsGaps = 20 * (imageGridRows - 1);
            imageGridHeight = mainImageHeight * imageGridRows + imageGridRowsGaps;
            $imgCollection.css({ height: imageGridHeight > 0 ? imageGridHeight : 'auto' });
          }

          //Container re-size checker
          $(window).on(
            'resize',
            _.debounce(function () {
              if ($imgCollection[0].style.height !== 'auto') {
                $imgCollection.css({ height: 'auto' });
              }
            }, 100)
          );

          // SPP alt video
          if (videoExists) {
            $videoContainers.once().on('click', function () {
              $videoActive = $(this);
              var opts = {
                openOverlay: true,
                provider: $videoActive.data('video-provider')
              };

              if ($videoActive.data('video-provider') === 'YouTube') {
                opts.youTubeId = $videoActive.data('video-source');
              } else if ($videoActive.data('video-provider') === 'MP4') {
                opts.mp4Source = $videoActive.data('video-source');
              }

              site.videos.open(opts);
            });
            $videoInlineContainers.once().on('click', function () {
              this.play();
            });
            $videoContainerWrappers.each(function () {
              var $videoContainerWrapper = $(this);
              var videoPosition = $videoContainerWrapper.data('video-position');
              var videoReplace = $videoContainerWrapper.data('video-replace');
              if (
                videoPosition < $('.js-product-full-image__img-wrap', $mainImageContainer).length
              ) {
                if (videoReplace) {
                  $(
                    '.js-product-full-image__img-wrap:nth-child(' + (videoPosition + 1) + ')',
                    $mainImageContainer
                  ).replaceWith($videoContainerWrapper.clone(true));
                } else {
                  $(
                    '.js-product-full-image__img-wrap:nth-child(' + videoPosition + ')',
                    $mainImageContainer
                  ).after($videoContainerWrapper.clone(true));
                }
              } else {
                $mainImageContainer.append($videoContainerWrapper.clone(true));
              }
            });
          }

          var $allWraps = $imgContainer.find('.js-product-full-image__img-wrap');
          var $altWraps = $allWraps.slice(1);
          var altCount = $altWraps.length;

          $mainImagesWrapper = $allWraps;
          $toggleBtn = $('.js-alt-toggle', $container);

          if (isDesktop) {
            if (altCount > altImageLimit) {
              collapseImages($altWraps);
              resizeImageGrid();
              $container.addClass('product-alt-collapse');
              $toggleBtn
                .show()
                .off('click.productExpand')
                .on('click.productExpand', function (e) {
                  e.preventDefault();
                  var $win = $(window);
                  var prevScrollTop = $win.scrollTop();
                  var currentState = self.isExpanded;
                  var isZoomed =
                    $mainImagesWrapper.hasClass('img-zoom-view') ||
                    $imgContainer.hasClass('img-zoom-view');

                  if (self.isExpanded) {
                    collapseImages($altWraps);
                  } else {
                    expandImages($altWraps);
                  }
                  resizeImageGrid();

                  if (currentState && isZoomed) {
                    var headerH = $('.js-site-header-formatter-v1').outerHeight(true) || 0;

                    (document.scrollingElement || document.documentElement).style.scrollPaddingTop =
                      headerH + 60 + 'px';
                    $toggleBtn[0].scrollIntoView({
                      behavior: 'smooth',
                      block: 'start'
                    });
                  } else {
                    requestAnimationFrame(function () {
                      $win.scrollTop(prevScrollTop);
                    });
                  }
                });
            } else {
              $toggleBtn.hide();
              $altWraps.show();
              $imgCollection.css({ height: 'auto' });
              resizeImageGrid();
            }
          } else {
            $toggleBtn.hide();
          }

          $mainImagesWrapper = $allWraps;

          $zoomIcon = $('.js-product-image-zoom-icon', $mainImagesWrapper);
          $zoomIcon.once().on('click keydown', function (e) {
            var eventType = e.type;
            var $this = $(this);

            if (e.key === 'Enter' || eventType === 'click') {
              $zoomIcon.toggleClass('close-icon');
              $mainImagesWrapper.add($imgContainer).toggleClass('img-zoom-view');
              $imageBadge.toggleClass('hidden');
              scrollToHeight = $this.parents($mainImagesWrapper).offset().top;
              var clickedIndex = $mainImagesWrapper.index(
                $this.closest('.js-product-full-image__img-wrap')
              );
              if (!$mainImagesWrapper.hasClass('img-zoom-view')) {
                scrollToHeight =
                  scrollToHeight - $('.js-site-header-formatter-v1').outerHeight(true);
                $zoomIcon.attr('aria-label', zoomLabel);
                if (clickedIndex <= 5 && !self.isExpanded) {
                  collapseImages($altWraps);
                } else {
                  expandImages($altWraps);
                }

                $('html, body').animate(
                  {
                    scrollTop: $mainImagesWrapper.eq(clickedIndex).offset().top
                  },
                  300
                );

                // Analytics zoom close event
                if (site && site.track) {
                  site.track.altImageZoomSelected({
                    zoomAction: 'close',
                    eventLabel: 'image_zoom_closed'
                  });
                }
              } else {
                $zoomIcon.attr('aria-label', closeLabel);
                $imgCollection.css({ height: 'auto' });
                if (
                  featureFlags['feature_bb_pdp_alt_image_collapse'] === true &&
                  clickedIndex > 5
                ) {
                  expandImages($altWraps);
                  $('html, body').animate(
                    {
                      scrollTop: $mainImagesWrapper.eq(clickedIndex).offset().top
                    },
                    300
                  );
                }
                // Analytics zoom open event
                var productElem = $this.closest('.js-product-full');
                var imageElem = $this
                  .closest('.js-product-full-image__img-wrap')
                  .find('.js-product-full-image-main-photo');

                if (site && site.track) {
                  site.track.altImageZoomSelected({
                    zoomAction: 'open',
                    eventLabel: productElem.length > 0 ? $(productElem[0]).data('product-id') : '',
                    imagePlacement: 'spp',
                    imageLabel:
                      imageElem.length > 0
                        ? Drupal.behaviors.productFullImageV2.fetchImageName(
                            $(imageElem[0]).attr('src')
                          )
                        : ''
                  });
                }
              }
              window.scrollTo({ top: scrollToHeight, behavior: 'smooth' });
              if (!$this.hasClass('close-icon') && eventType === 'click') {
                $this.blur();
              }
            }
          });

          if (!$textBadge.is(':empty')) {
            $mainImagesWrapper.first().append($textBadge);
          }

          $(document).on('product:vtoCtaClicked', '.js-product', function (e, payload) {
            var $zoomIcons = $('.js-product-image-zoom-icon');
            var $zoomedImages = $('.img-zoom-view');
            var $scrollTarget = $('.js-product-full-image-v2');
            var offsetTop;

            $zoomIcons.on('click', function () {
              $('.js-product-full__foundation-qrcode').addClass('hidden');
            });

            if ($zoomedImages.length > 0) {
              $zoomedImages.removeClass('img-zoom-view');
              $zoomIcons.removeClass('close-icon');

              $('.js-product-image-zoom-icon').attr('aria-label', zoomLabel);

              if ($scrollTarget.length > 0) {
                offsetTop =
                  $scrollTarget.offset().top - $('.js-site-header-formatter-v1').outerHeight(true);

                window.scrollTo({
                  top: offsetTop,
                  behavior: 'smooth'
                });
              }
            }
          });

          if (index > arrLen) {
            index = arrLen - 1;
          }

          self.initMainImageCarousel($container, index);
        }
      }
    },
    fetchImageName: function (imageUrl) {
      var imageName = '';

      if (imageUrl && imageUrl !== '' && imageUrl.includes('/')) {
        var imageArray = imageUrl.split('/');

        imageName = imageArray[imageArray.length - 1].split('?')[0];
      }

      return imageName;
    },
    attached: false
  };
})(jQuery);
